import React from "react";
import cns from "classnames";
import { withStyles } from "@material-ui/core";
import { Classes, ThemeType } from "@theme";
import Title from "./typography/Title";

type Props = {
  classes: Classes<typeof styles>;
  fitted?: boolean;
  style?: React.CSSProperties;
  mainText: string;
  smallText?: string;
  children?: React.ReactNode;
};

export const GroupHeadline: React.FC<Props> = ({
  classes,
  mainText,
  smallText,
  children,
  fitted,
  style
}) => {
  const content = children || mainText;

  return (
    <div className={cns(classes.root, { [classes.padded]: !fitted })} style={style}>
      <Title>
        {content}
        <span className={classes.smallText}>{" " + smallText}</span>
      </Title>
    </div>
  );
};

const styles = (theme: ThemeType) => ({
  root: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrast,
    padding: theme.spacing(),
    position: "sticky",
    top: 0,
    zIndex: 1
  },

  padded: {
    marginBottom: theme.spacing()
  },

  smallText: {
    fontSize: theme.typography.fontSize,
    opacity: 0.5,
    color: theme.palette.primary.contrast
  }
});

export default withStyles(styles as any)(GroupHeadline);
